import { FilterDocument } from '@griply/types';
import { getCompletedDateGroupSettings } from '@griply/utils';
import React, { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { ProvidedTaskFilterList } from 'shared/views/task-filter-list';

const emptyOrder = {};

export type TasksOverviewProps = {
  scrollElement?: React.RefObject<HTMLDivElement>;
  filterDocument: FilterDocument;
  setFilterDocument: React.Dispatch<React.SetStateAction<FilterDocument>>;
  defaultFilter: FilterDocument;
};

export const TasksOverview: React.FC<TasksOverviewProps> = ({
  scrollElement,
  filterDocument,
  setFilterDocument,
  defaultFilter,
}) => {
  const today = useToday();

  const onSectionCollapse = (collapsedSections: string[]) => {
    setFilterDocument((prev) => ({
      ...prev,
      collapsedSections,
    }));
  };

  const onReset = () => setFilterDocument(defaultFilter);

  const groupSettings = useMemo(
    () => getCompletedDateGroupSettings(today),
    [today],
  );

  return (
    <ProvidedTaskFilterList
      filterDocument={filterDocument}
      defaultFilterDocument={defaultFilter}
      onSectionCollapse={onSectionCollapse}
      scrollElement={scrollElement}
      onReset={onReset}
      customOrder={emptyOrder}
      groupSettings={groupSettings}
    />
  );
};
